import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./WelcomeSection.css";

const WelcomeSection = () => {
  return (
    <section className="welcome-section position-relative py-3 py-sm-4 py-md-5 px-2 px-sm-3 px-md-4 px-lg-5">
      <Container className="px-1 px-md-4 px-lg-5 mx-2 mx-1 mx-md-4 mx-lg-5">
        <div className=" px-1 px-md-4 px-lg-5 mx-2 mx-1 mx-md-4 mx-lg-5">
          <h2 className="fw-bold mb-4" style={{ color: "#2482a1" }}>
            Dear Friends,
          </h2>

          <p className="">
            Greetings from Chennai – the healthcare capital of India and the
            proud host of <strong>TNPY AMPICON 2025.</strong>
            <br></br>On behalf of the organizing committee, it is our privilege
            to invite you to the{" "}
            <span className="fw-bold" style={{ color: "#2482a1" }}>
              28<sup>th</sup>Annual Conference of the Association of Medical
              Physicists of India - Tamil Nadu and Puducherry Chapter, to be
              held on 26th–27th September 2025 at Apollo Cancer Centres,
              Vanagaram, Chennai.
            </span>
          </p>

          <p>
            Chennai has long stood as a global hub for advanced healthcare.{" "}
            <strong>
              At its heart, Apollo Cancer Centres Teynampet, has become the
              first in South Asia to introduce the next-generation CyberKnife®
              S7™ FIM Robotic Radiosurgery System,
            </strong>{" "}
            offering precise, non-invasive treatment for tumors. Continuing its
            legacy of innovation since launching{" "}
            <strong>India’s first CyberKnife® in 2008,</strong> Apollo sets a
            new benchmark in advanced cancer care across the Asia-Pacific
            region. Further strengthening this commitment, the{" "}
            <strong>Apollo Proton Cancer Centre </strong> stands as a monumental
            achievement in Indian oncology - the{" "}
            <strong>First Proton Therapy Facility in South Asia</strong>—firmly
            placing India on the global map for state-of-the-art cancer
            treatment. Adding further to this legacy,{" "}
            <strong>Apollo Vanagaram</strong> proudly hosts{" "}
            <strong>Tamil Nadu’s first Harmony PRO Linear Accelerator,</strong>{" "}
            offering cost-effective, high-precision, patient-friendly treatment
            capabilities.
          </p>

          <p>
            The theme for this year’s TNPY AMPICON 2025,{" "}
            <strong>
              <em>
                "Solving New Challenges in Personalized Oncology: Automation and
                Accuracy in Medical Physics,"
              </em>
            </strong>{" "}
            has been thoughtfully chosen to reflect the rapid evolution of
            clinical practices. With the growing integration of automation,
            artificial intelligence (AI), adaptive workflows, and data-driven
            decision-making, the role of Medical Physicists is undergoing a
            remarkable transformation.
          </p>

          <p>
            The pre-conference workshop on hybrid planning strategies and the
            annual TNPY AMPI Conference aim to spark meaningful discussions
            around these innovations, promote collaborative learning, and shape
            the future of <strong>Personalized Cancer Therapy.</strong>
          </p>

          <p>
            Join us for enriching scientific sessions, hands-on workshops, and
            impactful knowledge exchange with leading experts from across Tamil
            Nadu and India - all wrapped in the warmth of Chennai’s hospitality.
          </p>

          <p>We look forward to welcoming you!</p>

          <p className="fw-bold">
            Organizing Committee <br />
            <span style={{ color: "#2482a1", fontWeight: 800 }}>
              TNPY AMPICON 2025
            </span>{" "}
            <br />
            Apollo Cancer Centres - Vanagaram, Chennai
          </p>
        </div>
      </Container>
      <Container className="py-5 px-2 px-md-4 px-lg-5">
        <Row className="justify-content-center">
          <Col xs={12} md={6} className="mb-4">
            <Card border="primary" className="shadow-sm h-100">
              <Card.Body>
                <Card.Title
                  className="text-center"
                  style={{ color: "#2482a1" }}
                >
                  <strong>ORGANISING CHAIRMAN</strong>
                </Card.Title>
                <Card.Text className="text-center">
                  <strong>Dr. Harish Kumar K,</strong>
                  <span className="small fst-italic"> MD (RT),</span>
                  <br />
                  Lead Senior Consultant,
                  <br />
                  Apollo Cancer Centre,
                  <br />
                  Vanagaram, Chennai – 600095
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={6} className="mb-4">
            <Card border="primary" className="shadow-sm h-100">
              <Card.Body>
                <Card.Title
                  className="text-center"
                  style={{ color: "#2482a1" }}
                >
                  <strong>ORGANISING SECRETARY</strong>
                </Card.Title>
                <Card.Text className="text-center">
                  <strong>Dr. K Mohamathu Rafic,</strong>
                  <span className="small fst-italic"> Ph.D, MCMPI,</span>
                  <br />
                  Chief Medical Physicist & RSO,
                  <br />
                  Apollo Cancer Centre,
                  <br />
                  Vanagaram, Chennai – 600095
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WelcomeSection;
